import React, { Component } from "react";
import Combobox from 'react-widgets/lib/Combobox'
const isEmpty = require("is-empty");

class DenyModalComponent extends Component {
	state = {
		_id:                "",
		is_active:          "",
		name:               "",
		errorName:          "",
		isValidName:        false,
		description:        "",
		errorDescription:   "",
		isValidDescription: false,
		key:                "",
		errorKey:           "",
		isValidKey:         false,
		rol:		 		"",
		errorRol:          "",
		isValidRol:        false
	}

	constructor(props) {
		super(props);
		this.onChangeDescription = this.onChangeDescription.bind(this);
		this.preparateCreate     = this.preparateCreate.bind(this);
		this.preparateUpdate     = this.preparateUpdate.bind(this);
		this.onPressCancel       = this.onPressCancel.bind(this);
		this.deactivateDeny       = this.deactivateDeny.bind(this);
		this.onChangeName        = this.onChangeName.bind(this);
		this.onChangeRol        = this.onChangeRol.bind(this);
		this.activateDeny         = this.activateDeny.bind(this);
		this.escFunction         = this.escFunction.bind(this);
		this.onChangeKey         = this.onChangeKey.bind(this);
	}

	componentDidMount() {
		document.addEventListener("keydown", this.escFunction, false);
	}

	componentDidUpdate(prevProps) {
		if (this.props.modalDenyData) {
			if (this.props.modalDenyData !== prevProps.modalDenyData) {
				this.setState({
					_id: this.props.modalDenyData._id,
					name: this.props.modalDenyData.name,
					description: this.props.modalDenyData.description,
					key: this.props.modalDenyData.key,
					rol: this.props.modalDenyData.rol,
					is_active: this.props.modalDenyData.is_active
				})
			}
		}
	}

	///---------------------------------------EVENTS-------------------------------------
	escFunction(event) {
		if (event.keyCode === 27) {
			this.props.onPressCancel();
		}
	}

	async preparateCreate() {
		await this.clearErrors();
		this.validate();
		if (this.state.isValidName && this.state.isValidDescription && this.state.isValidKey && this.state.isValidRol) {
			this.props.createDeny({
				name:this.state.name,
				description:this.state.description,
				key:this.state.key,
				rol:this.state.rol
			});
			this.cleanForm();
		}
	}

	async preparateUpdate() {
		await this.clearErrors();
		this.validate();
		if (this.state.isValidName && this.state.isValidDescription && this.state.isValidKey && this.state.isValidRol) {
			this.props.updateDeny({
				id:this.state._id,
				name:this.state.name,
				description:this.state.description,
				key:this.state.key,
				rol:this.state.rol
			});
			this.cleanForm();
		}
	}

  	activateDeny() {
		this.props.activateDeny(this.props.modalDenyData._id);
	}

	deactivateDeny() {
		this.props.deactivateDeny(this.props.modalDenyData._id);
	}

	onPressCancel() {
		this.farmazonFormRef.reset();
		this.setState({
			description: '',
			name: '',
			key: '',
			rol:'',
			errorDescription: '',
			errorName: '',
			errorKey: '',
			errorRol: '',
		}, () => {
			this.props.onPressCancel();
		})
	}

  	onChangeName(e) {
		this.setState({
			name: e.target.value,
		})
	}

  	onChangeDescription(e) {
		this.setState({
			description: e.target.value,
		})
	}

  	onChangeKey(e) {
		this.setState({
			key: e.target.value,
		})
	}

	onChangeRol(value) {
		this.setState({
			rol: value._id,
		})
	}


  	clearErrors() {
		this.setState({
			errorDescription: "",
			errorName:        "",
			errorKey:         "",
			errorRol: "",
		})
	}

  	cleanForm() {
		this.farmazonFormRef.reset();
		this.setState({
			description:      "",
			name:             "",
			key:              "",
			rol:           "",
			errorDescription: "",
			errorName:        "",
			errorKey:         "",
			errorRol:          "",
		});
	}

  	validate() {
    	if (this.state.name === "" || isEmpty(this.state.name)) {
			this.setState({
				errorName: "El nombre de la denegación es requerido."
			})
		} 
		else {
			this.setState({
				isValidName: true
			})
		}

   		if (this.state.description === "" || isEmpty(this.state.description)) {
			this.setState({
				errorName: "La descripción de la denegación es requerida."
			})
		} 
		else {
			this.setState({
				isValidDescription: true
			})
		}   
    
    	if (this.state.key === "" || isEmpty(this.state.key)) {
			this.setState({
				errorName: "La clave de la denegación es requerida."
			})
		} 
		else {
			this.setState({
				isValidKey: true
			})
		}

		if (this.state.rol === "" || isEmpty(this.state.rol)) {
			this.setState({
				errorRol: "El rol del permiso es requerido."
			})
		} 
		else {
			this.setState({
				isValidRol: true
			})
		} 
  	}


	///---------------------------------------VIEW-------------------------------------
	render() {
    	var title = "CREACIÓN DE DENEGACIÓN";
		if (this.props.type === 'UPDATE') {
			title = "ACTUALIZACIÓN DE DENEGACIÓN";
		}

		let index = 0;
		if(this.props.roles && this.state.rol){
			index = this.props.roles.findIndex(rol => {
				return rol._id === this.state.rol;
			});
		}

		return (
			<div className={this.props.isVisible ? "modal display-block" : "modal display-none"}>
				<div className="modal-user-main">
					<div className="auth-group">
						{title}
						<div className="auth-label"></div>
						<div className="auth-label"></div>
						{
							<form ref={(el) => { this.farmazonFormRef = el }}>
							{
								<div className="auth-label">
									Nombre:
									<span className="required">*</span>
									<input
										id="nameForm"
										onChange={this.onChangeName}
										value={this.state.name || ""}
										error={this.state.errorName}
										type="title"
										placeholder={this.props.modalDenyData ? this.props.modalDenyData.name : "Ej.: No agregar productos a carrito."}
										className="local-store-input"
									/>
								</div>
							}
								<div className="auth-error">{this.state.errorName}</div>
							{
								<div className="auth-label">
									Descripción:
									<span className="required">*</span>
									<input
										id="descriptionForm"
										onChange={this.onChangeDescription}
										value={this.state.description}
										error={this.state.errorDescription}
										type="title"
										placeholder={this.props.modalDenyData ? this.props.modalDenyData.description : "Ej.: Denegación de permiso para agregar productos a carrito."}
										className="local-store-input"
									/>
								</div>
							}
							<div className="auth-error">{this.state.errorDescription}</div>
							{
								<div className="auth-label">
									Clave:
									<span className="required">*</span>
									<input
										id="keyForm"
										onChange={this.onChangeKey}
										value={this.state.key}
										error={this.state.errorKey}
										type="title"
										placeholder={this.props.modalDenyData ? this.props.modalDenyData.key : "Ej.: ADD_TO_CART"}
										className="local-store-input"
									/>
								</div>
							}
							{ this.state.rol && this.props.type === 'UPDATE' &&
								<div className="auth-label">
									Rol :
									<span className="required"> * </span>
									<Combobox
										className=""
										data={this.props.roles}
										dataKey='_id'
										textField='name'
										error={this.state.errorRol}
										defaultValue={this.props.roles[index]}
										onChange={this.onChangeRol.bind(this)}
									/>
								</div>
							}
							{ this.props.type === 'CREATE' &&
								<div className="auth-label">
									Rol :
									<span className="required"> * </span>
									<Combobox
										className=""
										data={this.props.roles}
										dataKey='_id'
										textField='name'
										error={this.state.errorRol}
										onChange={this.onChangeRol.bind(this)}
									/>
								</div>
							}
								<div className="auth-error">{this.state.errorRol}</div>
								<div className="auth-error">{this.state.errorKey}</div>
								<div className="auth-label"></div>
								<div className="auth-label"></div>
								<div className="auth-error">{this.props.error}</div>
							</form>
						}

						<div className="modal-activity-section">
						{
							this.props.type === 'UPDATE' &&
							<button className="modal-buttonOK" onClick={this.preparateUpdate}>ACTUALIZAR</button>
						}
						{
							this.props.type !== 'UPDATE' &&
							<button className="modal-buttonOK" onClick={this.preparateCreate}>GUARDAR</button>
						}
						{
							this.props.type === 'UPDATE' &&
							this.props.modalDenyData &&
							this.props.modalDenyData.is_active === false &&
							<button className="modal-buttonActivate" onClick={this.activateDeny}>ACTIVAR</button>
						}
						{
							this.props.type === 'UPDATE' &&
							this.props.modalDenyData &&
							this.props.modalDenyData.is_active &&
							<button className="modal-buttonDelete" onClick={this.deactivateDeny}>DESACTIVAR</button>
						}
						{
							<button className="modal-buttonNo" onClick={this.onPressCancel}>CERRAR</button>
						}
						</div>
					</div>
				</div>
			</div>
		);
  	}

}

export default DenyModalComponent;